import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/shared/guards/authGuard/auth.guard';
import { NgModule } from '@angular/core';
import { CargarFotoARLComponent } from './cargar-foto-arl.component';

const routes: Routes = [
    { path: 'foto/:tokenFoto', component: CargarFotoARLComponent },
    { path: 'arl/:tokenArl', component: CargarFotoARLComponent },
  ];

  @NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })
  
  export class CargarFotoARLRouting { }